import { apiClient } from './api';
import { buildNumber } from '@/settings/env';

function getBackEndVersion(): Promise<any> {
  return apiClient.get('/actuator/info').then((r) => {
    return JSON.parse(JSON.stringify(r.data));
  });
}

function getFrontVersion(): string {
  return buildNumber;
}

export { getBackEndVersion, getFrontVersion };
